export default __webpack_public_path__ + "static/media/home_img-top.3a206727.png";